<template>
    <div>
<div >
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on, attrs }">
          <v-btn v-if="acaoEditar == false" class="success" v-bind="attrs" v-on="on" >
              <v-icon left>mdi-plus</v-icon>
              <span>Novo barbeiro</span>
          </v-btn>

        <v-btn v-if="acaoEditar == true" class="ma-2 primary"  v-bind="attrs" v-on="on" >
            <v-icon left>mdi-pencil</v-icon>
            <span>Editar</span>
        </v-btn>

      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2">
          Novo barbeiro         

        </v-card-title>

        <div >
           <v-form class="pa-5" v-model="valid">
              
               <v-text-field :rules="inputRules"
               v-model="item.name" prepend-icon="fa fa-user"
               label="Nome do barbeiro" required>
    
               </v-text-field>


              <v-text-field  prepend-inner-icon="mdi-email"
              v-model="item.email" :rules="emailRules" 
              label="E-mail" required>
              </v-text-field>
              
              <v-text-field  prepend-inner-icon="mdi-phone"
              v-model="item.telefone" :rules="inputRules" 
              label="Telefone" required>
              </v-text-field>
              
              <v-text-field
              v-model="item.password" :rules="passRules" prepend-inner-icon="mdi-security"
              type="password" label="Senha" required>
              </v-text-field>
              
           </v-form>
        </div>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="!editar" :disabled="!valid" color="primary darken-2" @click="criarUsuario" :loading="loading"> 
            Criar
          </v-btn>
          <v-btn v-if="editar" :disabled="!valid" color="primary darken-2" @click="atualizarItem">
            Atualizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
    </div>
</template>

<script>
import { refBarbeiros} from '@/firebaseConfig'
import {mapActions} from 'vuex'
    export default {
      props: ['acaoEditar', 'itemPassado'],

        data(){
            return {
                valid: true,
                loading: false,
                editar: this.acaoEditar,
                disabled: false,
                 dbRef: refBarbeiros,
                 dialog: false,
                  date: null,
                    menu: false,
                 item: {
                   name:'',
                   email:'',
                   password:'',
                 },
                 inputRules: [
                    v => !!v || 'Este campo é obrigatório',
                     v => (v && v.length >= 3) || "Tamanho mínimo é 3 caractéres" 
                  ], 
                  passRules: [
                  v => !!v || 'Senha é obrigatória',
                  v => (v && v.length >= 6) || 'Senha precisa ser pelo menos 6 caracteres',
                ],
                emailRules: [
                    v => !!v || 'E-mail é obrigatório',
                    v => /.+@.+\..+/.test(v) || 'E-mail precisa ser váilido',
                  ],
                  

            }
        },
        

   

    methods: {
      ...mapActions(['signupBarbeiro']),

      checarCampos(){
        return  typeof this.item.nome === 'undefined' || this.item.nome === ''
      //  ||  typeof this.item.nascimento === 'undefined' || this.item.nascimento === ''
      },
       async criarUsuario(){
          let bool = false

          this.loading = true;

          bool = await this.signupBarbeiro(
            {email: this.item.email,
            password: this.item.password,
            name: this.item.name,
            telefone: this.item.telefone});

            

            if(bool){
              this.criarNovoItem()
            }else{
              alert(this.$store.getters.getLoginError)
            }
            //this.$router.push("admin/home");


      },
      async criarNovoItem(){
        
        console.log("registrar")
        let barbeiro = {
          nome: this.item.name,
          email: this.item.email,
          telefone: this.item.telefone
          //nome: this.item.name,
        }
        this.dbRef.add(barbeiro).then(async(ref)  => {
            console.log(ref);
            //this.barbeiro.id = ref.id;
            
            //ref.set(this.barbeiro);
            //this.dbRef.doc(ref.id).update(this.barbeiro);
            await ref.update({id:ref.id });
           
            this.loading = false;
            setTimeout(() => {
              this.$emit('recarregarLista');  
            }, 1000);
            

        })
            

            this.dialog = false

      },
     
      atualizarItem(){
                console.log("atualizar")
                console.log(this.item)
                
                this.dbRef.doc(this.item.id).update({nome: this.item.nome, nascimento: this.item.nascimento}).then(() => {
                  this.$toasted.global.defaultSuccess("Atualizado com sucesso!");
                    //this.Funcoes.carregar();
                    this.$emit('recarregarLista');

                });
               
            

            this.dialog = false;

            //this._vm.$forceUpdate();


      },
    ajustarPagina(){
        
        console.log(this.editar)
       if(this.editar == true){
         this.item = this.itemPassado;
         this.date = this.item.nascimento;
       }
      }
    },
    created() {
      this.ajustarPagina()
    }
    }
</script>

<style lang="scss" scoped>

</style>